import { Box } from "@mui/system";
import { FC } from "react";
import { CustomTooltipProps } from "../../../util/types";
import { useThemeContext } from "../../../globalContext/global-context";
import { tooltipClassName, tooltipContentSx, tooltipWrapperSx } from "./styles";

const CustomTooltip: FC<CustomTooltipProps> = ({
  title,
  children,
  placement = "top",
  disableInteractive = false,
  maxWidth = 300,
}) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  return (
    <Box component="span" sx={tooltipWrapperSx()}>
      {children}
      {title && (
        <Box
          role="tooltip"
          className={tooltipClassName}
          sx={tooltipContentSx(placement, disableInteractive, maxWidth, theme)}
        >
          {title}
        </Box>
      )}
    </Box>
  );
};

export default CustomTooltip;
